(function ($) {
    var taint, d, x, y;
    $(".button").mouseover(function (e) {
        var hit = false;

        if (!hit) {
            if ($(this).find(".button-hover").length == 0) {
                $(this).prepend("<div class='button-hover'></div>")
            } else {
                return;
            }
            taint = $(this).find(".button-hover");
            taint.removeClass("drop");
            if (!taint.height() && !taint.width()) {
                d = Math.max($(this).outerWidth(), $(this).outerHeight());
                taint.css({
                    height: d,
                    width: d
                });
            }
            x = e.pageX - $(this).offset().left - taint.width() / 2;
            y = e.pageY - $(this).offset().top - taint.height() / 2;
            taint.css({
                top: y + 'px',
                left: x + 'px'
            }).addClass("drop");
            hit = true;
        }
    });

    $('.button').mouseleave(function (e) {
        var thisButtonHover = $(this).find('.button-hover');
        thisButtonHover.removeClass('drop');
        setTimeout(function () {
            thisButtonHover.remove();
        }, 300);
    })
})(jQuery);